import { checkImg } from "../api"

export const statusMap = {
    0: '未激活',
    1: "已激活",
    2: "待审核",
    3: "未通过",
    4: "报修中",
    5: "已使用",
}

export const orderStatusMap = {
    0: "待审核", 1: "审核通过，待维修", 2: "审核不通过", 3: "订单完结", 4: "维修中，请耐心等待", 5: "维修完成，已寄回", 6: "审核通过，可执行换机操作", 7: "寄件完成", 8: '维修中',
}
export const exchangeStatusMap = {
    0: "待审核", 1: "审核通过", 2: "审核不通过"
}
export const checkImgFun = async function (filename) {
    if (filename) {
        const res = await checkImg({ filename })
        const response = res.data;
        if (response.code === "200") {
            return response.data;
        }
    } else {
        return ''
    }
}


// WEBPACK FOOTER //
// ./src/utils/common.js